module.exports = __webpack_public_path__ + "img/news2.3fe13e99.jpg";